


import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import DirectCodeInput from '@/components/DirectCodeInput/index.vue';
import ResponsiveImage from '@/components/utils/ResponsiveImage/index.vue';
import { RouteNames } from '@/utils/router/router.models';
import { tRoute } from '@/utils/plugins/i18nRoutes';
import { Notification, NotificationType } from '@/components/NotificationBanner/NotificationBanner.models';
import SimpleRoundedLoader from '../../components/utils/SimpleRoundedLoader/index.vue';

const appModule = namespace('app');
const configurationModule = namespace('configuration');
const notifyModule = namespace('notify');

@Component({
  components: {
    DirectCodeInput,
    ResponsiveImage,
    SimpleRoundedLoader
  }
})
export default class MobileHome extends Vue {
  @appModule.Getter private isMobile!: boolean;

  @configurationModule.Action private getPDF!: (code: string) => string;
  @notifyModule.Action private showNotification!: (data: Notification) => void;
  @notifyModule.Action private closeNotification!: (key: string) => Promise<void>;

  private pdfLoading = false;

  private image = {
    MQ1: require('@/assets/images/mobile_bg_portrait.jpg'),
    MQ2: require('@/assets/images/mobile_bg_portrait.jpg'),
    MQ3: require('@/assets/images/mobile_bg_portrait.jpg'),
    MQ4: require('@/assets/images/mobile_bg_portrait.jpg'),
    MQ5: require('@/assets/images/mobile_bg_portrait.jpg'),
    MQ6: require('@/assets/images/mobile_bg_portrait.jpg')
  };

  private async submitCode(code: string) {
    this.pdfLoading = true;

    const PDFUrl: string = await this.getPDF(code);

    this.pdfLoading = false;

    if (PDFUrl) {
      const a = document.createElement('a');

      a.style.display = 'none';
      a.href = PDFUrl;
      a.target = '_blank';
      a.download = `${code}.pdf`;
      document.body.appendChild(a);

      a.click();

      // Firefox hack with setTimeout
      setTimeout(() => {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(PDFUrl);
      }, 100);
    } else {
      this.onCodeError();
    }
  }

  private onCodeError() {
    this.showNotification({
      headline: this.$t('components.directCode.error') as string,
      type: NotificationType.Error,
      key: 'OnlineCode/codeInvalid'
    });
  }

  private closeValidationMessage() {
    this.closeNotification('OnlineCode/codeInvalid');
  }

  @Watch('isMobile')
  private mobileChanged(to: boolean) {
    if (!to) this.$router.replace(tRoute(RouteNames.Home));
  }
}
